module.exports = __webpack_public_path__ + "static/media/galerija_2021 (25)-min.e607b7fc.jpg";